
import service from '../../common/service'

const pageService = new service({baseUrl:'/web/page'});

export default {
    namespaced:true,
    state:{
        loaded:false,
        page:{},
        elements:[],
        carousels:[],
    },
    getters:{
        page:(state)=>state.page,
        elements:(state)=>state.elements,
        carousels:(state)=>state.carousels
    },
    mutations:{
        setPage:(state,d)=>{
            state.page = {...d};
        },
        setElements:(state,d)=>{
            state.elements = [...d];
        },
        setCarousels:(state,d)=>{
            state.carousels = [...d];
        }
    },
    actions:{
        fetch_page( context ){
            return pageService.get('1').then((res)=>{
                const json = res.data;
                if(json.success){
                    let page = json.data;
                    try{
                        page.layout = JSON.parse(page.layout||'{}');
                    }catch (e) {
                        page.layout = [{}];
                    }
                    context.commit('setPage',page);
                }
            })
        },
        fetch_home( context ){
            return pageService.get('1/home').then((res)=>{
                const json = res.data;
                if(json.success){
                    let data = json.data;
                    context.commit('setElements',data.elements||[]);
                    context.commit('setCarousels',data.carousels||[]);
                }
            })
        }
    }
}